import PropTypes from 'prop-types'
import { MarkerItem } from '@calendly/booking-kit'
import { TitleText } from '@calendly/ui/components/typography'


const Marker = ({ text, bookingAppRedesign = false }) => (
  <MarkerItem>
    <TitleText size={bookingAppRedesign ? 'small' : 'large'} level={2}>{text}</TitleText>
  </MarkerItem>
)

Marker.propTypes = {
  text: PropTypes.string.isRequired,
  bookingAppRedesign: PropTypes.bool
}

export default Marker
